import { createRoot } from "react-dom/client"
import invariant from "tiny-invariant"
import Root from "./Root"

const container = document.getElementById("app")
invariant(container != null, "No app container element in document")

export const data = container.dataset
const inBook = data.title !== undefined
const previous = data.previous
const next = data.next

const root = createRoot(container)
root.render(<Root inBook={inBook} previous={previous} next={next} />)
container.classList.add("h-0")

/*
if (process.env.NODE_ENV !== "production") {
  import("@axe-core/react").then(axe => {
    axe(React, root, 1000)
  })
}
*/
